<template>
<v-container>

    <v-divider class="mt-12"></v-divider>
    <h4 class="text-center">Mis Clientes</h4>
    <v-divider></v-divider>

    <v-btn 
    block
    class="mx-auto mb-2"
    color="success" 
    dark @click.stop="clienteuno={},
    activo=false,
    $store.commit('dialogClienteGeneral')" >
    Nuevo Cliente</v-btn>

     <v-text-field
     append-icon="mdi-magnify"
                v-model="buscar"
                label="BUSCA CLIENTE"
                required
    ></v-text-field>

        <v-sheet
      id="scrolling-techniques"
      class="overflow-y-auto"
      max-height="350"
    >
    <v-container>

        <v-layout row wrap pa-2>
            <v-flex 
            class="mt-n2 pa-1"
            v-for="cliente in listafiltrada"  v-bind:key="cliente['.key']"
            xs12 md4>
                    <v-alert
                        border="left"
                        colored-border
                        color="deep-purple accent-4"
                        elevation="2"
                        icon="fas fa-user-check"
                        
                        >
                        <p class="body-2"><strong> Nombre:</strong> {{cliente.nombreCompleto}}</p>
                        <p class="body-2 mt-n4"><strong> Celular:</strong> {{cliente.celular}}</p>
                    <v-btn color="error" text class="overline">Enviar Oferta</v-btn>
                     <v-btn 
                     color="success" 
                     text class="overline" 
                     @click="clienteuno=cliente,
                        activo=true,
                        $store.commit('dialogClienteGeneral')">Ver cliente</v-btn>
                    </v-alert>
            </v-flex>
        </v-layout>
    </v-container>
        </v-sheet>
        <dialogClienteGeneral :clienteuno="clienteuno" :activo="activo" />
 </v-container>
</template>

<script>
// @ is an alias to /src
import dialogClienteGeneral from '@/components/dialogClienteGeneral'
import { db } from '../db'

export default {
  name: 'gestionClientes',
      
    firebase: {
        clientes: db.database().ref("cliente"),

    },
    components: {
        dialogClienteGeneral,
    },

    data() {
        return{
    clientes:[],
    clienteuno:{},
    dialog:false,
    buscar:''
    }
    },

     computed: {
        listafiltrada() {

            return this.clientes.filter((item)=> item.dni.includes(this.buscar) )
            }
    }
  
}
</script>
